import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { usePaymentIntent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/hooks/usePaymentIntent';
import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';

export const useLoanPaymentIntent = () => {
  const { createPaymentIntent, refreshPaymentMethodEntity, updatePaymentMethodEntity } = usePaymentIntent();
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  const mountPaymentIntent = async (
    paymentMethodDetailEntity: LoanPaymentMethodDetailEntity,
    openMerchantPos: () => void,
  ) => {
    if (!checkoutSessionEntity) {
      throw new Error('Checkout session entity not found');
    }

    if (paymentMethodDetailEntity.shouldCreatePaymentIntent()) {
      throw new Error('Payment intent must be created before mounting');
    }

    openMerchantPos();
  };

  return {
    createPaymentIntent,
    mountPaymentIntent,
    refreshPaymentMethodEntity,
    updatePaymentMethodEntity,
  };
};
